export { default as ScalarVirtualText } from "./ScalarVirtualText.vue.js";
